import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supabase } from '../../lib/supabase'

export default function Sidebar() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/login')
  }

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
  }

  const navItems = [
    { path: '/',         label: t('nav.home'),     icon: '⌂', end: true },
    { path: '/receipts', label: t('nav.receipts'), icon: '🧾' },
    { path: '/mileage',  label: t('nav.mileage'),  icon: '🚗' },
    { path: '/reports',  label: t('nav.reports'),  icon: '📄' },
    { path: '/settings', label: t('nav.settings'), icon: '⚙' },
    { path: '/help',     label: t('nav.help'),     icon: '?' },
  ]

  return (
    <div style={styles.sidebar}>
      <div style={styles.logo}>
        <span style={styles.logoMerq}>Merq</span><span style={styles.logoLog}>Log</span>
      </div>

      <nav style={styles.nav}>
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            style={({ isActive }) => ({
              ...styles.navItem,
              ...(isActive ? styles.navItemActive : {})
            })}
          >
            <span style={styles.navIcon}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div style={styles.bottom}>
        <div style={styles.langSwitcher}>
          {['en', 'es'].map(lang => (
            <button
              key={lang}
              onClick={() => changeLanguage(lang)}
              style={{
                ...styles.langBtn,
                ...(i18n.language === lang ? styles.langBtnActive : {})
              }}
              aria-label={lang === 'en' ? 'English' : 'Español'}
            >
              {lang === 'en' ? '🇺🇸' : '🇲🇽'}
            </button>
          ))}
        </div>
        <button onClick={handleLogout} style={styles.logout}>
          {t('auth.logout')}
        </button>
      </div>
    </div>
  )
}

const styles = {
  sidebar: {
    width: '220px',
    background: '#0B1220',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    position: 'sticky',
    top: 0,
    height: '100vh',
    flexShrink: 0,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
  logo: {
    padding: '24px 20px',
    fontSize: '24px',
    fontWeight: '900',
    fontFamily: "'Fraunces', serif",
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    marginBottom: '8px',
    letterSpacing: '-0.5px',
  },
  logoMerq: { color: '#fff' },
  logoLog: { color: '#14B8A6', fontStyle: 'italic' },
  nav: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 0',
    overflowY: 'auto',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '11px 20px',
    color: '#94A3B8',
    fontSize: '14px',
    fontWeight: '500',
    textDecoration: 'none',
    borderLeft: '3px solid transparent',
    transition: 'all 0.15s',
  },
  navItemActive: {
    color: '#fff',
    borderLeft: '3px solid #14B8A6',
    background: 'rgba(20,184,166,0.08)',
  },
  navIcon: {
    fontSize: '16px',
    width: '20px',
    textAlign: 'center',
  },
  bottom: {
    padding: '16px 20px',
    borderTop: '1px solid rgba(255,255,255,0.08)',
  },
  langSwitcher: {
    display: 'flex',
    gap: '8px',
    marginBottom: '12px',
  },
  langBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '6px',
    padding: '4px 10px',
    fontSize: '16px',
    cursor: 'pointer',
    opacity: 0.55,
    transition: 'all 0.15s',
  },
  langBtnActive: {
    opacity: 1,
    border: '1px solid #14B8A6',
    background: 'rgba(20,184,166,0.1)',
  },
  logout: {
    width: '100%',
    padding: '9px',
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '8px',
    color: '#94A3B8',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    textAlign: 'center',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    transition: 'all 0.15s',
  }
}
